// Pure helpers for the Available-releases dropdown — kept out of the
// component so the sorting + bucketing logic is easy to read in isolation
// and trivially unit-testable when we eventually add coverage here.

// Sort descending by version using a "natural" numeric-aware compare so
// `2603.0.1-prod` sorts above `2603.0-prod`, `2604.0-prod` above
// `2603.0-prod`, etc. Newest tag floats to the top of the dropdown.
export const sortReleasesDesc = (releases: string[]): string[] =>
  [...releases].sort((a, b) =>
    b.localeCompare(a, undefined, { numeric: true, sensitivity: 'base' }),
  );

export interface GroupedReleases {
  prod: string[];
  uat: string[];
  other: string[];
}

// Bucket releases into PROD / UAT / Other for the grouped dropdown.
//   *-prod                → PROD
//   *-rc<n>               → UAT (release candidates deploy to UAT)
//   everything else       → Other
export const groupReleases = (sorted: string[]): GroupedReleases => {
  const prod: string[] = [];
  const uat: string[] = [];
  const other: string[] = [];
  for (const r of sorted) {
    if (/-prod$/i.test(r)) prod.push(r);
    else if (/-rc\d*$/i.test(r)) uat.push(r);
    else other.push(r);
  }
  return { prod, uat, other };
};
